// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/agent_conversation_service.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Attachment, UploadAttachment } from "./common_pb.ts";
import { GetAgentsThreadResponse } from "./agents_service_pb.ts";

/**
 * @generated from message protogen.AgentConversationThread
 */
export class AgentConversationThread extends Message<AgentConversationThread> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: int64 createdAtSec = 3;
   */
  createdAtSec = protoInt64.zero;

  /**
   * @generated from field: int64 lastMessageAtSec = 4;
   */
  lastMessageAtSec = protoInt64.zero;

  /**
   * @generated from field: string lastMessagePreview = 5;
   */
  lastMessagePreview = "";

  constructor(data?: PartialMessage<AgentConversationThread>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AgentConversationThread";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "createdAtSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "lastMessageAtSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "lastMessagePreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentConversationThread {
    return new AgentConversationThread().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentConversationThread {
    return new AgentConversationThread().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentConversationThread {
    return new AgentConversationThread().fromJsonString(jsonString, options);
  }

  static equals(a: AgentConversationThread | PlainMessage<AgentConversationThread> | undefined, b: AgentConversationThread | PlainMessage<AgentConversationThread> | undefined): boolean {
    return proto3.util.equals(AgentConversationThread, a, b);
  }
}

/**
 * @generated from message protogen.AgentConversationMessage
 */
export class AgentConversationMessage extends Message<AgentConversationMessage> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string content = 2;
   */
  content = "";

  /**
   * @generated from field: string richContent = 3;
   */
  richContent = "";

  /**
   * @generated from field: string senderRef = 4;
   */
  senderRef = "";

  /**
   * @generated from field: int64 timestampSec = 5;
   */
  timestampSec = protoInt64.zero;

  /**
   * @generated from field: repeated protogen.Attachment attachments = 6;
   */
  attachments: Attachment[] = [];

  /**
   * @generated from field: string agentThreadRef = 7;
   */
  agentThreadRef = "";

  /**
   * @generated from field: optional protogen.GetAgentsThreadResponse agentThread = 8;
   */
  agentThread?: GetAgentsThreadResponse;

  constructor(data?: PartialMessage<AgentConversationMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AgentConversationMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "richContent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "senderRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "timestampSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "attachments", kind: "message", T: Attachment, repeated: true },
    { no: 7, name: "agentThreadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "agentThread", kind: "message", T: GetAgentsThreadResponse, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentConversationMessage {
    return new AgentConversationMessage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentConversationMessage {
    return new AgentConversationMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentConversationMessage {
    return new AgentConversationMessage().fromJsonString(jsonString, options);
  }

  static equals(a: AgentConversationMessage | PlainMessage<AgentConversationMessage> | undefined, b: AgentConversationMessage | PlainMessage<AgentConversationMessage> | undefined): boolean {
    return proto3.util.equals(AgentConversationMessage, a, b);
  }
}

/**
 * @generated from message protogen.ListAgentConversationsRequest
 */
export class ListAgentConversationsRequest extends Message<ListAgentConversationsRequest> {
  constructor(data?: PartialMessage<ListAgentConversationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAgentConversationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAgentConversationsRequest {
    return new ListAgentConversationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAgentConversationsRequest {
    return new ListAgentConversationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAgentConversationsRequest {
    return new ListAgentConversationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAgentConversationsRequest | PlainMessage<ListAgentConversationsRequest> | undefined, b: ListAgentConversationsRequest | PlainMessage<ListAgentConversationsRequest> | undefined): boolean {
    return proto3.util.equals(ListAgentConversationsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListAgentConversationsResponse
 */
export class ListAgentConversationsResponse extends Message<ListAgentConversationsResponse> {
  /**
   * @generated from field: repeated protogen.AgentConversationThread threads = 1;
   */
  threads: AgentConversationThread[] = [];

  constructor(data?: PartialMessage<ListAgentConversationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAgentConversationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "threads", kind: "message", T: AgentConversationThread, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAgentConversationsResponse {
    return new ListAgentConversationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAgentConversationsResponse {
    return new ListAgentConversationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAgentConversationsResponse {
    return new ListAgentConversationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAgentConversationsResponse | PlainMessage<ListAgentConversationsResponse> | undefined, b: ListAgentConversationsResponse | PlainMessage<ListAgentConversationsResponse> | undefined): boolean {
    return proto3.util.equals(ListAgentConversationsResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetAgentConversationRequest
 */
export class GetAgentConversationRequest extends Message<GetAgentConversationRequest> {
  /**
   * @generated from field: string conversationRef = 1;
   */
  conversationRef = "";

  /**
   * @generated from field: string startCursor = 2;
   */
  startCursor = "";

  /**
   * @generated from field: int32 pageSize = 3;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<GetAgentConversationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAgentConversationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "conversationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "startCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "pageSize", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentConversationRequest {
    return new GetAgentConversationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentConversationRequest {
    return new GetAgentConversationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentConversationRequest {
    return new GetAgentConversationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentConversationRequest | PlainMessage<GetAgentConversationRequest> | undefined, b: GetAgentConversationRequest | PlainMessage<GetAgentConversationRequest> | undefined): boolean {
    return proto3.util.equals(GetAgentConversationRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetAgentConversationResponse
 */
export class GetAgentConversationResponse extends Message<GetAgentConversationResponse> {
  /**
   * @generated from field: protogen.AgentConversationThread thread = 1;
   */
  thread?: AgentConversationThread;

  /**
   * @generated from field: repeated protogen.AgentConversationMessage messages = 2;
   */
  messages: AgentConversationMessage[] = [];

  /**
   * @generated from field: string nextCursor = 3;
   */
  nextCursor = "";

  /**
   * @generated from field: bool hasMore = 4;
   */
  hasMore = false;

  constructor(data?: PartialMessage<GetAgentConversationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAgentConversationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "thread", kind: "message", T: AgentConversationThread },
    { no: 2, name: "messages", kind: "message", T: AgentConversationMessage, repeated: true },
    { no: 3, name: "nextCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "hasMore", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentConversationResponse {
    return new GetAgentConversationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentConversationResponse {
    return new GetAgentConversationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentConversationResponse {
    return new GetAgentConversationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentConversationResponse | PlainMessage<GetAgentConversationResponse> | undefined, b: GetAgentConversationResponse | PlainMessage<GetAgentConversationResponse> | undefined): boolean {
    return proto3.util.equals(GetAgentConversationResponse, a, b);
  }
}

/**
 * conversationRef is optional; omit to create a new conversation on first message.
 *
 * @generated from message protogen.SendAgentMessageRequest
 */
export class SendAgentMessageRequest extends Message<SendAgentMessageRequest> {
  /**
   * @generated from field: string conversationRef = 1;
   */
  conversationRef = "";

  /**
   * @generated from field: string content = 2;
   */
  content = "";

  /**
   * @generated from field: string richContent = 3;
   */
  richContent = "";

  /**
   * @generated from field: repeated protogen.UploadAttachment attachments = 4;
   */
  attachments: UploadAttachment[] = [];

  constructor(data?: PartialMessage<SendAgentMessageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SendAgentMessageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "conversationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "richContent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attachments", kind: "message", T: UploadAttachment, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendAgentMessageRequest {
    return new SendAgentMessageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendAgentMessageRequest {
    return new SendAgentMessageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendAgentMessageRequest {
    return new SendAgentMessageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendAgentMessageRequest | PlainMessage<SendAgentMessageRequest> | undefined, b: SendAgentMessageRequest | PlainMessage<SendAgentMessageRequest> | undefined): boolean {
    return proto3.util.equals(SendAgentMessageRequest, a, b);
  }
}

/**
 * @generated from message protogen.SendAgentMessageResponse
 */
export class SendAgentMessageResponse extends Message<SendAgentMessageResponse> {
  /**
   * @generated from field: protogen.AgentConversationMessage message = 1;
   */
  message?: AgentConversationMessage;

  /**
   * Populated only when a new conversation was created by this request.
   *
   * @generated from field: optional protogen.AgentConversationThread thread = 2;
   */
  thread?: AgentConversationThread;

  /**
   * @generated from field: string agentThreadRef = 3;
   */
  agentThreadRef = "";

  constructor(data?: PartialMessage<SendAgentMessageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SendAgentMessageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message", kind: "message", T: AgentConversationMessage },
    { no: 2, name: "thread", kind: "message", T: AgentConversationThread, opt: true },
    { no: 3, name: "agentThreadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendAgentMessageResponse {
    return new SendAgentMessageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendAgentMessageResponse {
    return new SendAgentMessageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendAgentMessageResponse {
    return new SendAgentMessageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendAgentMessageResponse | PlainMessage<SendAgentMessageResponse> | undefined, b: SendAgentMessageResponse | PlainMessage<SendAgentMessageResponse> | undefined): boolean {
    return proto3.util.equals(SendAgentMessageResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListSmsBotConversationsRequest
 */
export class ListSmsBotConversationsRequest extends Message<ListSmsBotConversationsRequest> {
  constructor(data?: PartialMessage<ListSmsBotConversationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListSmsBotConversationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSmsBotConversationsRequest {
    return new ListSmsBotConversationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSmsBotConversationsRequest {
    return new ListSmsBotConversationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSmsBotConversationsRequest {
    return new ListSmsBotConversationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSmsBotConversationsRequest | PlainMessage<ListSmsBotConversationsRequest> | undefined, b: ListSmsBotConversationsRequest | PlainMessage<ListSmsBotConversationsRequest> | undefined): boolean {
    return proto3.util.equals(ListSmsBotConversationsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListSmsBotConversationsResponse
 */
export class ListSmsBotConversationsResponse extends Message<ListSmsBotConversationsResponse> {
  /**
   * @generated from field: repeated protogen.AgentConversationThread threads = 1;
   */
  threads: AgentConversationThread[] = [];

  constructor(data?: PartialMessage<ListSmsBotConversationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListSmsBotConversationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "threads", kind: "message", T: AgentConversationThread, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSmsBotConversationsResponse {
    return new ListSmsBotConversationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSmsBotConversationsResponse {
    return new ListSmsBotConversationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSmsBotConversationsResponse {
    return new ListSmsBotConversationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSmsBotConversationsResponse | PlainMessage<ListSmsBotConversationsResponse> | undefined, b: ListSmsBotConversationsResponse | PlainMessage<ListSmsBotConversationsResponse> | undefined): boolean {
    return proto3.util.equals(ListSmsBotConversationsResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetSmsBotConversationRequest
 */
export class GetSmsBotConversationRequest extends Message<GetSmsBotConversationRequest> {
  /**
   * @generated from field: string startCursor = 1;
   */
  startCursor = "";

  /**
   * @generated from field: int32 pageSize = 2;
   */
  pageSize = 0;

  /**
   * @generated from field: string conversationRef = 3;
   */
  conversationRef = "";

  constructor(data?: PartialMessage<GetSmsBotConversationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetSmsBotConversationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "startCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pageSize", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "conversationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSmsBotConversationRequest {
    return new GetSmsBotConversationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSmsBotConversationRequest {
    return new GetSmsBotConversationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSmsBotConversationRequest {
    return new GetSmsBotConversationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSmsBotConversationRequest | PlainMessage<GetSmsBotConversationRequest> | undefined, b: GetSmsBotConversationRequest | PlainMessage<GetSmsBotConversationRequest> | undefined): boolean {
    return proto3.util.equals(GetSmsBotConversationRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetSmsBotConversationResponse
 */
export class GetSmsBotConversationResponse extends Message<GetSmsBotConversationResponse> {
  /**
   * @generated from field: optional protogen.AgentConversationThread thread = 1;
   */
  thread?: AgentConversationThread;

  /**
   * @generated from field: repeated protogen.AgentConversationMessage messages = 2;
   */
  messages: AgentConversationMessage[] = [];

  /**
   * @generated from field: string nextCursor = 3;
   */
  nextCursor = "";

  /**
   * @generated from field: bool hasMore = 4;
   */
  hasMore = false;

  constructor(data?: PartialMessage<GetSmsBotConversationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetSmsBotConversationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "thread", kind: "message", T: AgentConversationThread, opt: true },
    { no: 2, name: "messages", kind: "message", T: AgentConversationMessage, repeated: true },
    { no: 3, name: "nextCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "hasMore", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSmsBotConversationResponse {
    return new GetSmsBotConversationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSmsBotConversationResponse {
    return new GetSmsBotConversationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSmsBotConversationResponse {
    return new GetSmsBotConversationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSmsBotConversationResponse | PlainMessage<GetSmsBotConversationResponse> | undefined, b: GetSmsBotConversationResponse | PlainMessage<GetSmsBotConversationResponse> | undefined): boolean {
    return proto3.util.equals(GetSmsBotConversationResponse, a, b);
  }
}

